import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from '../../../components/Seo';

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { ExpertLicenses } from '../../../components/ExpertLicenses';
import { Licenses } from '../../../components/Licenses';
import { AdvanceNoRocket } from '../../../components/AdvanceNoRocket';
import { SmiAboutUs } from '../../../components/SmiAboutUs';
import { Modal } from '../../../components/Modal';
import { TaxDeduction } from '../../../components/TaxDeduction';
import { HeaderLogoAndTel } from '../../../components/HeaderLogoAndTel';
import { GetCourseWidget } from '../../../components/GetCourseWidget';
import { FooterFull } from '../../../components/FooterFull';

import * as main from './styles/main.module.scss';
import * as screen1 from './styles/screen1.module.scss';
import * as about from './styles/about.module.scss';
import * as course from './styles/course.module.scss';
import * as pattern from './styles/pattern.module.scss';
import * as offer from './styles/offer.module.scss';
import * as speaker from './styles/speaker.module.scss';
import * as advance from './styles/advance.module.scss';
const Screen1 = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel logo={'orange'} phoneColor={'#FFF'} />
        <div className={screen1.screen1__mainContent}>
          <h1>
            Мини-курс
            <span>Английский для туристов</span>
          </h1>

          <p className={screen1.screen1__desc}>Станьте экскурсоводом за&nbsp;2&nbsp;дня</p>

          <div className={main.cost}>
            <p className={main.costPrice}>
              3 500<span>₽</span>
            </p>
            <p className={main.costOffer}>
              590<span>₽</span>
            </p>
          </div>

          <div className={screen1.screen1__btnInfo}>
            <div className={screen1.screen1__btnInfo__row}>
              <div className={screen1.screen1__btnInfo__col}>
                <button
                  className={`btn ${main.blockBtn}`}
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  Купить
                </button>
              </div>
              <TaxDeduction className={screen1.screen1__tax} />
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </header>
  );
};
const About = () => {
  return (
    <section className={`${about.about} ${main.sec}`}>
      <div className="container">
        <h2 className={about.aboutTitle}>Всего за&nbsp;8&nbsp;уроков вы</h2>
        <div className={`row ${about.about__row}`}>
          <div className={`col col-4 ${about.about__col}`}>
            <img
              className={about.aboutImg}
              src="https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_turistov/notepad.svg"
              alt="notepad"
            />
            <p className={about.aboutImgName}>Выучите</p>
            <p className={about.aboutImgDesc}>
              224 английских <br /> слова
            </p>
          </div>

          <div className={`col col-4 ${about.about__col}`}>
            <img
              className={about.aboutImg}
              src="https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_turistov/isaakiy.svg"
              alt="isaaky"
            />
            <p className={about.aboutImgName}>Узнаете</p>
            <p className={about.aboutImgDesc}>
              множество интересных <br />
              исторических фактов <br />
              о&nbsp;Санкт-Петербурге <br />
              и научитесь самостоятельно <br />
              рассказывать о&nbsp;них <br />
              на&nbsp;английском
            </p>
          </div>

          <div className={`col col-4 ${about.about__col}`}>
            <img
              className={about.aboutImg}
              src="https://fs.advance.ru/landing-pages/online/angliyskiy_dlya_turistov/certificate.svg"
              alt="certificate"
            />
            <p className={about.aboutImgName}>Получите</p>
            <p className={about.aboutImgDesc}>
              именной сертификат <br /> от&nbsp;Advance
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
const Course = () => {
  return (
    <section className={`${course.course} ${main.sec}`}>
      <div className="container">
        <h2 className={course.courseTitle}>Из чего состоит курс:</h2>
        <div className="row">
          <div className={`col col-6 ${course.course__col}`}>
            <div className="row">
              <div className={`col col-12 ${course.course__colInner}`}>
                <div className={course.courseStructure}>
                  <p className={course.courseStructureNum}>8</p>
                  <p className={course.courseStructureName}>видеоуроков</p>
                  <p className={course.courseDesc}>
                    на суммарное время просмотра 60&nbsp;минут. Каждый урок расскажет вам увлекательные факты
                    о&nbsp;достопримечательностях <br />
                    Санкт-Петербурга.
                  </p>
                  <p className={course.courseDescSub}>
                    Вы узнате как описать дорогу к&nbsp;какому-либо месту, <br />
                    как рассказать в&nbsp;каком году что-либо построено <br />
                    или возведено и&nbsp;кем, как описать здание или парк, <br />
                    как будет по-английски <b>“памятник”</b>, <b>“фасад”</b>, <b>“проспект”</b>,<b>“канал”</b>,{' '}
                    <b>“основывать”</b>, <b>“четный/нечетный”</b>, <b>”стоять лицом к”</b>,<b>“гулять вдоль”</b>{' '}
                    и&nbsp;т.д.
                  </p>
                </div>
              </div>
              <div className={`col col-12 ${course.course__colInner}`}>
                <div className={course.courseStructure}>
                  <p className={course.courseStructureNum}>224</p>
                  <p className={course.courseStructureName}>
                    слова туристической <br />
                    и&nbsp;экскурсионной тематики
                  </p>
                  <p className={course.courseDesc}>
                    Которые вы сможете использовать, чтобы проводить экскурсии самостоятельно или чтобы слушать
                    экскурсии и&nbsp;задавать <br />
                    вопросы экскурсоводу в&nbsp;путешествиях
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className={`col col-6 ${course.course__col}`}>
            <div className="row">
              <div className={`col col-12 ${course.course__colInner}`}>
                <div className={course.courseStructure}>
                  <p className={course.courseStructureNum}>8</p>
                  <p className={course.courseStructureName}>упражнений с&nbsp;паттернами</p>
                  <p className={course.courseDesc}>
                    (языковыми конструкциями). <br />
                    Которые позволят выучить и закрепить незнакомые слова в контексте.
                  </p>
                </div>
              </div>
              <div className={`col col-12 ${course.course__colInner}`}>
                <div className={course.courseStructure}>
                  <p className={course.courseStructureNum}>8</p>
                  <p className={course.courseStructureName}>упражнений на проверку</p>
                  <p className={course.courseDesc}>Которые позволят проверить, всю ли лексику вы запомнили</p>
                </div>
              </div>
              <div className={`col col-12 ${course.course__colInner}`}>
                <div className={course.courseStructure}>
                  <p className={course.courseStructureNum}>282</p>
                  <p className={course.courseStructureName}>
                    паттернов <br />
                    (языковых конструкций)
                  </p>
                  <p className={course.courseDesc}>
                    Которые помогут вам научиться использовать слова в&nbsp;контексте, не&nbsp;путать предлоги
                    и&nbsp;времена.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
const Pattern = () => {
  return (
    <section className={`${pattern.pattern} ${main.sec}`}>
      <div className="container">
        <div className="row">
          <div className={`col col-4 ${pattern.patternCol4}`}></div>
          <div className={`col col-8 ${pattern.patternCol8}`}>
            <p className={pattern.patternTitle}>Что лежит в&nbsp;основе эффективности нашей системы?</p>
            <p className={pattern.patternDesc}>
              Паттерны –&nbsp;лингвистический тренажер применяемый для&nbsp;ускоренного освоения иностранных языков,
              а&nbsp;именно:
            </p>
            <ul className={pattern.patternDescList}>
              <li>постановки разговорного навыка</li>
              <li>перевода слов в&nbsp;активный словарный запас</li>
              <li>введение в&nbsp;речь новых грамматических конструкций и&nbsp;оборотов</li>
            </ul>
            <p className={pattern.patternSubscr}>
              Плюсы паттернов в&nbsp;сравнении с&nbsp;другими инструментами и&nbsp;разговорной практикой:
            </p>
            <ul className={pattern.patternSubscrList}>
              <li>
                Процесс выполнения паттернов прекрасно имитирует речевую деятельность, <br />
                включая все этапы продукции речи (выбор конструкции, слов, составление фразы, вербализации)
              </li>
              <li>
                Процесс не&nbsp;допускает появления ошибок и&nbsp;русскостей в речи –&nbsp;топорного копирования
                грамматических и&nbsp;лексических конструкций с&nbsp;русского (сравнение с&nbsp;правильным вариантом
                идет сразу, далее закрепление несколькими проходами)
              </li>
              <li>
                Паттерны подобраны таким образом, чтобы достаточное для&nbsp;автоматизации количество раз были
                отработаны все нужные грамматические конструкции и слова в&nbsp;нужных контекстах
              </li>
              <li>
                Большая интенсивность в&nbsp;сравнении с&nbsp;разговорной практикой (в&nbsp;5-8&nbsp;раз) и&nbsp;любыми
                другими инструментами.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
const Offer = ({ widget }) => {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <section className={`${offer.offer} ${main.sec}`}>
      <div className="container">
        <div className={main.cost}>
          <p className={main.costPrice}>
            3 500<span>₽</span>
          </p>
          <p className={main.costOffer}>
            590<span>₽</span>
          </p>
          <button
            className={`btn ${main.blockBtn}`}
            onClick={() => {
              setShowModal(true);
            }}
          >
            Купить
          </button>
          <TaxDeduction font={'18px'} color={'#FFF'} />
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
const Speaker = () => {
  return (
    <section className={`${speaker.speaker} ${main.sec}`}>
      <div className="container">
        <h2 className={speaker.speaker__title}>Преподаватель</h2>
        <div className={`row ${speaker.speaker__row}`}>
          <div className={speaker.speaker__imageBlock}>
            <div className={speaker.speaker__descWrapper}>
              <h3 className={speaker.speaker__descName}>Екатерина Каменская</h3>
              <p className={speaker.speaker__descProf}>Преподаватель английского языка</p>
            </div>
          </div>
          <ul className={speaker.speaker__list}>
            <li>Образование: Факультет международных экономических отношений СПбГЭУ, красный диплом;</li>
            <li>Педагогический стаж с&nbsp;2013 года;</li>
            <li>Свободно владеет испанским и английским языками;</li>
            <li>Являлась директором английского лагеря в&nbsp;Черногории;</li>
            <li>
              Проживала в&nbsp;США и&nbsp;Испании в&nbsp;целях совершенствования английского и&nbsp;испанского языков
              и&nbsp;повышения квалификации.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};
const Advance = () => {
  return (
    <>
      <AdvanceNoRocket
        sectionName={`${advance.noRocket} ${main.sec}`}
        ttlName={advance.noRocketTitle}
        colCustomize={`col ${advance.noRocketCol}`}
        yearsTxt={'учим людей раскрывать и развивать свой интеллектуальный потенциал, повышать личную эффективность'}
        pplCountTxt={'человек приняли участие в наших курсах и семинарах'}
        pplCoursesTxt={'человек прошли наши полные курсы'}
      />
      <section className={advance.advance}>
        <div className="container">
          <h2 className={advance.advance__title}>Нас ценят эксперты образования</h2>
          <ExpertLicenses navColor={'#FE4C04'} />
        </div>
      </section>
      <section className={`${advance.advance} ${advance.advanceDevelop}`}>
        <div className="container">
          <h2 className={advance.advance__title}>Мы развиваем образование</h2>
          <Licenses navColor={'#FE4C04'} />
        </div>
      </section>
      <SmiAboutUs sectionName={`${advance.smi} ${main.sec}`} ttlName={advance.smiTitle} />
    </>
  );
};

const TITLE = 'Курс английского для путешествий | Онлайн уроки английского для туристов';
const DESCRIPTION =
  'Онлайн-курс Английский для туризма: освойте методы запоминания слов. Подходит для начинающих (Beginner, Elementary). Экспресс курс для поездок за границу.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = ({ widget = <GetCourseWidget hash={'e738402ead7ae42b377599fbf45d66681b7a1234'} id={'222256'} /> }) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: `"Montserrat", sans-serif`, color: '#353535' }}>
      <Screen1 widget={widget} />
      <About />
      <Course />
      <Pattern />
      <Offer widget={widget} />
      <Speaker />
      <Advance />
    </main>

    <FooterFull />
  </DefaultLayout>
);
export default Page;
